import Date_ from './Date_'

export default class DateEquals extends Date_ {
  get ruleName () {
    return 'dateEquals'
  }

  passes () {
    return this.momentFormat(this.value).isSame(this.momentFormat(this.date), 'd')
  }
}
